import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import { useNavigate } from 'react-router-dom';

const TaskMobileLineItem = ({
  id = null,
  data,
  strings,
}) => {
  const navigate = useNavigate();

  let dividerColor;
  let taskStatus;

  switch (data.job.state) {
    case 'draft':
      taskStatus = data.job.state;
      dividerColor = Theme.Color.$bluedarker;
      break;
    case 'submitted':
      taskStatus = data.job.state;
      dividerColor = Theme.Color.$gold;
      break;
    case 'rejected':
      taskStatus = data.job.state;
      dividerColor = Theme.Color.$red;
      break;
    default:
      if (data.state === 'unassigned') {
        taskStatus = data.job.state;
        dividerColor = Theme.Color.$green;
      } else if (data.state === 'assigned') {
        taskStatus = data.state;
        dividerColor = Theme.Color.$gold;
      } else if (data.state === 'waiting_for_acknowledgement') {
        taskStatus = data.state;
        dividerColor = Theme.Color.$gold;
      } else {
        switch (data.state) {
          case 'acknowledged':
          case 'started':
          case 'arrived':
          case 'collected':
            dividerColor = Theme.Color.$green;
            break;
          case 'cancelled':
            dividerColor = Theme.Color.$red;
            break;
          case 'failed':
            dividerColor = Theme.Color.$red;
            break;
          case 'successful':
            dividerColor = Theme.Color.$green;
            break;
          default:
            dividerColor = Theme.Color.$white;
        }
        taskStatus = data.state;
      }
      break;
  }

  const content = (
    <div className="vf-task__mobile-line-item__content">

      <div className="vf-task__mobile-line-item__content__row">
        <span className="vf-task__mobile-line-item__content__row__title">
          {data.billing_account
            ? data.billing_account.name
            : data.job.customer.name}
        </span>
        {
          data.archived === true ? false : (
            <span className="vf-task__mobile-line-item__content__row__status">
              {strings.Task.status[taskStatus]}
            </span>
          )
        }
        {
          data.archived === true ? false : (
            <Components.Mobile.Divider
              color={dividerColor}
            />
          )
        }
      </div>

      <div className="vf-task__mobile-line-item__content__row">
        <Components.CircleIcon
          className="vf-task__mobile-line-item__content__row__type-icon"
          iconClassName={data.job.job_type === 'pickup' ? 'versa-arrow-up' : 'versa-arrow-down'}
          iconText=""
        />
        <div className="vf-task__mobile-line-item__content__row__details">
          <div>{Utils.Formatter.getInlineAddress(data.address)}</div>
          <div>
            {Utils.Formatter.formatRangeTime(data.time_from, data.time_to)}
          </div>
        </div>
      </div>
      {
        !Utils.Helper.isNullOrUndefined((data || {}).tags) && data.tags.length > 0
          ? (
            <Components.Tags
              tags={data.tags.map(tag => tag.name)}
            />
          ) : false
      }
    </div>
  );

  return (
    <Components.Mobile.LineItem
      content={content}
      id={id}
      key={data.id}
      onClick={() => navigate(`/tasks/${data.id}`)}
    />
  );
};

TaskMobileLineItem.displayName = 'Task Mobile Line Item';

TaskMobileLineItem.propTypes = {
  data: PropTypes.shape().isRequired,
  id: PropTypes.string,
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      status: PropTypes.shape(),
    }),
  }).isRequired,
};

export default translate('')(TaskMobileLineItem);
